import { Pipe, PipeTransform } from '@angular/core';
import { ActiveStatusPill, InactiveStatusPill } from '../../../models/shared/submission-status-pill';
import { EmploymentHistoryStatus } from '../../../models/users/enum/employment-history-status';
import { EmploymentStatusTypeId } from '../../../models/employers/enum/employment-status-type-id';

@Pipe({
  name: 'employmentStatusPill'
})
export class EmploymentStatusPillPipe implements PipeTransform {
  transform(statusId: EmploymentStatusTypeId | EmploymentHistoryStatus): ActiveStatusPill | InactiveStatusPill {
    if (statusId === EmploymentStatusTypeId.Active) {
      return new ActiveStatusPill();
    } else {
      return new InactiveStatusPill();
    }
  }
}
